import { ActivityStatus } from '../../interfaces/activity'
import { FundingRequestStatus } from '../../interfaces/bbc'
import { BoxSignStatus } from '../../interfaces/box'
import { FilterFieldType, IFilter } from './types'

export const TREASURY_SUMMARY_FILTERS_CONFIG = [
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Text,
    excludeColumn: true,
  },
] as const satisfies IFilter[]

export const TREASURY_FUNDING_WIRES_FILTERS_CONFIG = [
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Text,
    excludeColumn: true,
  },
  {
    field: 'description',
    dbField: 'client_name',
    alias: 'clientInfo',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Description',
    align: 'left',
  },
  {
    field: 'type',
    dbField: `(CASE WHEN "treasuryDetails"."borrowing_base_id" IS NULL AND "treasuryDetails".is_prediction = TRUE THEN 'Atlas Predicted' WHEN "treasuryDetails"."borrowing_base_id" IS NULL AND "treasuryDetails".is_prediction = FALSE THEN 'User Predicted' ELSE "borrowingBase".requested_amount_type END)`,
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Type',
  },
  {
    field: 'bbcStatus',
    dbField: `(
        CASE 
          WHEN activity.status = '${ActivityStatus.NotStarted}' THEN 1
          WHEN activity.status = '${ActivityStatus.InProgress}' THEN 2
          WHEN activity.status = '${ActivityStatus.Review}' THEN 3
          WHEN borrowingBase.status = '${FundingRequestStatus.Sent}' THEN 9
          WHEN boxSignInfo.sign_status = '${BoxSignStatus.created}' THEN 4
          WHEN boxSignInfo.sign_status = '${BoxSignStatus.sent}' THEN 5
          WHEN boxSignInfo.sign_status = '${BoxSignStatus.viewed}' THEN 6
          WHEN boxSignInfo.sign_status = '${BoxSignStatus.signed}' THEN 7
          WHEN activity.status = '${ActivityStatus.Complete}' THEN 8
          WHEN activity.status = '${ActivityStatus.Archived}' THEN 10
          ELSE 11
        END
    )`,
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Status',
  },
  {
    field: 'amount',
    dbField: 'COALESCE(fundings.amount, treasuryDetails.amount)',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Amount',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'left',
  },
] as const satisfies IFilter[]

export const TREASURY_OTHER_WIRES_FILTERS_CONFIG = [
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Text,
    excludeColumn: true,
  },
  {
    field: 'description',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Description',
    align: 'left',
  },
  {
    field: 'amount',
    dbField: '"treasuryDetails".amount',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Amount',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'left',
  },
] as const satisfies IFilter[]

export const TREASURY_PARTICIPATION_WIRES_FILTERS_CONFIG = [
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Text,
    excludeColumn: true,
  },
  {
    field: 'description',
    dbField: `CONCAT_WS(' ', "treasuryDetails".client_name, "treasuryDetails".participant, "treasuryDetails".participation_wire_type)`,
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Description',
    align: 'left',
  },
  {
    field: 'amount',
    dbField: 'COALESCE("participationWires".amount, "treasuryDetails".amount)',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Amount',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'left',
  },
] as const satisfies IFilter[]

export const TREASURY_PASSTHROUGH_WIRES_FILTERS_CONFIG = [
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Text,
    excludeColumn: true,
  },
  {
    field: 'description',
    dbField: 'client_name',
    alias: 'treasuryDetails',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Description',
    align: 'left',
  },
  {
    field: 'amount',
    dbField: 'COALESCE("passThrough".amount, "treasuryDetails".amount)',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Amount',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'left',
  },
] as const satisfies IFilter[]
